var map = {
	"./bills.png": 64672,
	"./bills.svg": 56782,
	"./clothes.png": 30726,
	"./clothes.svg": 4640,
	"./coffee.png": 30916,
	"./coffee.svg": 48484,
	"./creditcards.png": 67894,
	"./creditcards.svg": 57068,
	"./dark_excludedfromanalysisicon.png": 58614,
	"./dark_excludedfromanalysisicon.svg": 61516,
	"./debts.png": 87600,
	"./debts.svg": 32718,
	"./drinks.png": 31413,
	"./drinks.svg": 99025,
	"./eatingout.png": 13104,
	"./eatingout.svg": 92030,
	"./education.png": 49768,
	"./education.svg": 74170,
	"./entertainment.png": 85852,
	"./entertainment.svg": 85714,
	"./family.png": 73036,
	"./family.svg": 4472,
	"./fitness.png": 67106,
	"./fitness.svg": 93672,
	"./gambling.png": 24937,
	"./gambling.svg": 60361,
	"./gifts.png": 74283,
	"./gifts.svg": 42389,
	"./groceries.png": 16491,
	"./groceries.svg": 75757,
	"./holiday.png": 17286,
	"./holiday.svg": 30860,
	"./home&garden.png": 18468,
	"./home&garden.svg": 44186,
	"./home.png": 75341,
	"./home.svg": 39389,
	"./insurance.png": 23426,
	"./insurance.svg": 61031,
	"./insurnace.png": 94360,
	"./insurnace.svg": 11206,
	"./internaltransfers.png": 31975,
	"./internaltransfers.svg": 86009,
	"./internaltransfersicon.png": 66708,
	"./internaltransfersicon.svg": 33990,
	"./investments.png": 3840,
	"./investments.svg": 70678,
	"./largepurchases.png": 33835,
	"./largepurchases.svg": 10459,
	"./medical.png": 25923,
	"./medical.svg": 16381,
	"./other.png": 26488,
	"./other.svg": 5574,
	"./pets.png": 43634,
	"./pets.svg": 76730,
	"./resources.png": 36129,
	"./resources.svg": 84839,
	"./salary.png": 29726,
	"./salary.svg": 63558,
	"./savings.png": 6519,
	"./savings.svg": 38693,
	"./selfcare.png": 44765,
	"./selfcare.svg": 25817,
	"./shopping.png": 23840,
	"./shopping.svg": 87820,
	"./socialising.png": 11561,
	"./socialising.svg": 77411,
	"./takeaways.png": 53448,
	"./takeaways.svg": 1822,
	"./transport.png": 32177,
	"./transport.svg": 40231,
	"./travel.png": 52908,
	"./travel.svg": 12668,
	"./uncategorized.png": 80540,
	"./uncategorized.svg": 92026,
	"./vehicle.png": 23706,
	"./vehicle.svg": 59544
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21530;